import { SET_ON_APPLICATION_STARTED } from '../types/interactions/ISkyfireSetOnApplicationStartedMethod';
import { getParameterByName, globals } from '../utils';
export const LocalStorageMiddleware = (store) => (next) => async (action) => {
    next(action);
    if (action.type === SET_ON_APPLICATION_STARTED) {
        const { deviceId } = store.getState().Authentication;
        const env = getParameterByName('skyfireEnv', globals.location.href);
        const key = `${deviceId}_${env}_onStart`;
        globals.localStorage.setItem(key, JSON.stringify(action.payload.onApplicationStarted));
    }
};
